export default __webpack_public_path__ + "static/media/phone.9802fadc.svg";